<template>
  <div>
    <div class="position-relative">
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
    <li class="breadcrumb-item"><router-link to="/solutions/overview">Solutions</router-link></li>
    <li class="breadcrumb-item active" aria-current="page">Services Structure</li>
  </ol>
</nav>

<div class="row">

<div class="col-lg-8 p-2">
<h2 class="title">Services Structure</h2>
                <p class="lead">
                  Universal Tech LLC is a one-stop multi-vendor provider of data
                  center hardware and equipment across all major IT brands.
                  Besides offering a wide range of servers, storage, and
                  networking products, Universal Tech LLC provides clients with
                  the flexibility to sell and consign data center equipment to
                  us via asset trade-in and buy-back programs. This eliminates
                  the cost of storing their excess or end-of-life assets,
                  optimizing the value of their enterprise equipment. </p><p class="lead">Whether it
                  is new resale, pre-owned, or end-of-life hardware, Universal
                  Tech LLC is a vendor- agnostic provider of cost-efficient,
                  quality hardware solutions all around the world. We offer
                  options to rent servers, storage, and networking equipment
                  from one-week to one-year. We also buy-back old equipment so
                  clients can use the funds towards new IT projects and
                  initiatives.
                </p>
<div class="bg-secondary p-2" id="dataerasure">
               <p class="lead">
                <b>Data Erasure & Destruction</b> 
                <p>Universal Tech LLC offers both on-site and secure offsite data erasure and data destruction services. We provide documentation for records to meet any corporate, federal, or state compliance requirements (i.e., the full chain of custody documentation, receipt of materials, and certificate of sanitization).
               </p>

   <p class="lead" id="assetrecovery" >
                <b>Asset Recovery & Recycling</b> 
                <p>With an emphasis on reuse, Universal Tech LLC optimizes the value and prolongs the lifespan of data center equipment via reverse logistics, extracting maximum value from retiring technology. Our holistic suite of services includes the assessment, verification, recovery, refurbishment, reconfiguration, and resale or recycling of equipment, which can be customized to meet the client’s business needs.
</p>

   <p class="lead" id="datacentermove">
                <b>Migrations & Data Center Moves</b> 
                <p>We serve as a single point of contact for any professional services, or logistics clients may need for data migrations and/or data center moves. We help plan the project from start to finish and apply best practices at every step to ensure data is safe and secure.
</p>

   <p class="lead">
                <b>Migration Services</b> 
                <ul class="unstyled-list">
                  <li>Database Migration</li>
<li>Custom Application Migration</li>
<li>Legacy Systems Conversion</li>
                </ul>
</p>

 <p class="lead">
                <b>Managed Support Services</b> 
                <ul>
                  <li>Oracle and SAP Application Support</li>
<li>Database Support</li>
<li>Systems Support</li>
                </ul>
</p>

 <p class="lead">
                <b>ERP Business Solutions</b> 
                <ul>
                  <li>Oracle EBS Implementation</li>
<li>SAP Implementation</li>
<li>Custom Application Development</li>
                </ul>
</p>
             
</div>


</div>

<div class="col-lg-4">
    <OverviewSideNav></OverviewSideNav>
</div>
         
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import OverviewSideNav from "./OverviewSideNav";
export default {
  name: "ServicesStructure",
  components : {
    OverviewSideNav
  }
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>
